<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { addNotification } from '$lib/components/notifications/notifications';
	import HorizontalStackedBarChart from '$lib/components/route-details/HorizontalStackedBarChart.svelte';
	import { trackLaunchpadClick } from '$lib/services/tracking/googleAnalytics/launchpad';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import { formatPrice } from '$lib/utils/formatPrice';
	import * as m from '$paraglide/messages';
	import { languageTag } from '$paraglide/runtime';

	const searchParams = getSearchParamsStore();

	function handleCostCalculateClick() {
		trackLaunchpadClick('launchpad_itinerary_calculate');
		gotoWithParams('/routes', { ...$searchParams });
		addNotification(m.launchpad__cost_notification());
	}

</script>

<section class="flex flex-col justify-center flex-wrap items-center">
	<h3 class="text-center text-balance uppercase text-sm text-coloredneutral-soft font-600 my-0 mb-2 font-smooth">{m.launchpad__cost_title()}</h3>
	<div class="w-280px">
		<HorizontalStackedBarChart classes="border-coloredneutral-weakest shadow-smooth-block bg-neutral-weakest p-4 rounded-8px" datasets={[
			{
				colorClass: 'bg-quick-weak',
				description: formatPrice({
					amount: 49,
					currency: 'EUR',
					language: languageTag(),
					digits: 2,
				}),
				label: m.route_details__costs_section__fuel(),
				nb: 16.5,
			},
			{
				colorClass: 'bg-economic-weak',
				description: formatPrice({
					amount: 18,
					currency: 'EUR',
					language: languageTag(),
					digits: 2,
				}),
				label: m.route_details__costs_section__tolls(),
				nb: 22.6,
			},
		]}
		/>
	</div>
	<Button
		variant="filled"
		color="light"
		size="md"
		icon="directions"
		iconPosition="right"
		text={m.launchpad__cost_cta_label()}
		class="relative bottom-0 translate-y--4 shadow-smooth-block"
		onclick={handleCostCalculateClick}
	/>
</section>
